import React, { useState } from "react"
import { useTranslation } from "react-i18next"

const GenerateTokenModal = ({ generated, onClose }) => {
  const { t } = useTranslation()
  const [copied, setCopied] = useState(false)

  if (!generated) return null

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(generated.connection_string)
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    } catch {
      // clipboard unavailable — оставляем поле для ручного выделения
    }
  }

  return (
    <div className="fixed inset-0 bg-black/30 z-[60] flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl border border-[#E7EAEF] max-w-md w-full p-5">
        <h2 className="text-base font-semibold text-[#1F2937] mb-1">
          {t("admin_extension_tokens.generate_modal.title")}
        </h2>
        <p className="text-sm text-[#9AA5B4] mb-4">
          {t("admin_extension_tokens.generate_modal.subtitle", {
            name: generated.user?.name || generated.user?.email,
          })}
        </p>

        <div className="bg-[#F4F6F9] rounded-xl px-3 py-2.5 text-xs font-mono text-[#1F2937] break-all mb-3">
          {generated.connection_string}
        </div>

        <p className="text-xs text-[#EF4444] mb-4">
          {t("admin_extension_tokens.generate_modal.warning")}
        </p>

        <div className="flex gap-2">
          <button
            onClick={handleCopy}
            className="flex-1 px-3 py-2 rounded-xl bg-[#1F2937] text-white text-sm font-medium
                       hover:bg-[#111827] transition-colors"
          >
            {copied
              ? t("admin_extension_tokens.generate_modal.copied")
              : t("admin_extension_tokens.generate_modal.copy")}
          </button>
          <button
            onClick={onClose}
            className="flex-1 px-3 py-2 rounded-xl border border-[#E7EAEF] text-sm font-medium text-[#1F2937]
                       hover:bg-[#F4F6F9] transition-colors"
          >
            {t("admin_extension_tokens.generate_modal.close")}
          </button>
        </div>
      </div>
    </div>
  )
}

export default GenerateTokenModal
